import React from 'react'
import "./Footer.scss"


const Footer = () => {
    return (
        <div className='footer'>
            <div>Movie Finder</div>
            <div>2023, Movie, Inc. </div>
        </div>
    )
}

export default Footer